import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[var(--ink)] text-[var(--cream)]">
      <div className="relative hidden lg:block overflow-hidden">
        <img src="/img/ivcasa-coppia-chiavi-di-casa-con-scritte.jpg" alt="IVCasa" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0d1411]/30" />
      </div>
      <div className="flex flex-col justify-center px-6 sm:px-16 py-16 relative grain">
        <div className="relative z-10 max-w-md w-full mx-auto">
          <Link to="/" data-testid="admin-login-back-link" className="inline-flex items-center gap-2 text-sm text-[var(--mute-d)] hover:text-[var(--cream)]"><ArrowLeft className="w-4 h-4" /> Torna al sito</Link>
          <img src="/img/logo_ivcasa_white_sm.png" alt="IVCasa" className="h-12 mt-10" />
          <h1 className="font-display text-5xl mt-10">Area riservata</h1>
          <p className="text-[var(--mute-d)] mt-3 text-sm">Accesso per lo staff IVCasa: gestione annunci e richieste.</p>
          <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
            <Input data-testid="admin-login-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 rounded-none border-0 border-b border-white/25 bg-transparent px-0 focus-visible:ring-0 focus-visible:border-[var(--green)] placeholder:text-white/50" />
            <Input data-testid="admin-login-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-12 rounded-none border-0 border-b border-white/25 bg-transparent px-0 focus-visible:ring-0 focus-visible:border-[var(--green)] placeholder:text-white/50" />
            {error && <p data-testid="admin-login-error" className="text-sm text-red-300">{error}</p>}
            <button type="submit" disabled={busy} data-testid="admin-login-submit-button"
              className="w-full h-14 rounded-full bg-[var(--green)] text-sm font-semibold flex items-center justify-center gap-2 hover:bg-[var(--green-deep)] transition-colors disabled:opacity-60">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Accedi
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
